<template>
  <div class="wc-team-logo">
    <img v-if="logoSrc && !failed" :src="logoSrc" :alt="name" @error="failed = true">
    <span v-else>{{ text }}</span>
  </div>
</template>

<script>
import { resolveTeamLogo, placeholderText } from '../utils/teamFlag'

export default {
  name: 'WorldCupTeamLogo',
  props: {
    src: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      failed: false
    }
  },
  computed: {
    logoSrc() {
      return resolveTeamLogo(this.src)
    },
    text() {
      return placeholderText(this.name)
    }
  },
  watch: {
    src() {
      this.failed = false
    }
  }
}
</script>

<style scoped lang="scss">
.wc-team-logo {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: 50%;
  background: #e5e7eb;
  overflow: hidden;
  color: #8a9099;
  font-size: 12px;
  line-height: 28px;
  text-align: center;
}

.wc-team-logo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
